import * as React from 'react'
import g from 'glamorous'

const FALLBACK = '—'

const FooterContainer = g.footer({
  padding: '1em',
  marginTop: '2em',
  borderTop: '1px solid #eee',
  textAlign: 'center',
  fontSize: '0.85em',
  color: '#888'
})

const Footer: React.SFC<{}> = () => {
  const serverIp = process.env.REACT_APP_SERVER_IP || FALLBACK
  return (
    <FooterContainer>
      Server IP: <strong>{serverIp}</strong>
    </FooterContainer>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.tsx